import React from 'react'
import ArrowLeft from '@Images/arrow-left.svg'
import ArrowRight from '@Images/arrow-right.svg'

interface CarouselArrowButtonProps {
  readonly side: 'left' | 'right'
  onClick(): void
}

const CarouselArrowButton: React.FC<CarouselArrowButtonProps> = (props) => {
  const { side, onClick } = props
  const label = side === 'left' ? 'Previous slide' : 'Next slide'

  return (
    <button
      className="TipsPreview__arrow"
      onClick={onClick}
      type="button"
      aria-label={label}
    >
      {side === 'left' ? <ArrowLeft /> : <ArrowRight />}
    </button>
  )
}

export default CarouselArrowButton
